import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/auth';
import { getFormUrl } from '../../utils/formUrl';
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  SearchPanel,
  GroupPanel,
  Grouping,
  FilterPanel,
  HeaderFilter,
  Lookup,
  Toolbar
} from 'devextreme-react/data-grid';
import Button from 'devextreme-react/button';
import Tabs from 'devextreme-react/tabs';
import 'devextreme-react/text-area';
import { Item } from 'devextreme-react/form';
import VerifyPopup from '../../components/verifyPopup/VerifyPopup';
import './TempaleGrid.css';
import LoadIndicator from "devextreme-react/load-indicator";
import { Row } from 'devextreme-react/responsive-box';
import notify from 'devextreme/ui/notify';


const notesEditorOptions = { height: 100 };
const { REACT_APP_SERVER_URL } = process.env;

function TempaleGrid(props) {
  const [isLoadIndicatorVisible, setIsLoadIndicatorVisible] = useState(true);
  const [selectedTask_id, setSelectedTask_id] = useState("");
  const [selectedTaskName, setSelectedTaskName] = useState("");
  const [tasks, setTasks] = useState([]);
  const [agentTasks, setAgentTasks] = useState([]);
  const [agreementType, setAgreementType] = useState('הכל');
  const [status, setStatus] = useState('הכל');
  const [selectedTypeIndex, setSelectedTypeIndex] = useState(0);
  const [selectedStatusIndex, setSelectedStatusIndex] = useState(1);
  const [filterValue, setfilterValue] = useState(['clientResponse', '=', true]);
  const [loadingMessageFlag, setLoadingMessageFlag] = useState(true);

  const [isMessagePopupVisible, setMessagePopupVisibility] = useState(false);
  const [popupMessageContent, setPopupMessageContent] = useState('');
  const [getAgentTasksFlag, setGetAgentTasksFlag] = useState(true);
  const [lastSigningDateColumnFlag, setLastSigningDateColumnFlag] = useState(false);
  const { user } = useAuth();
  useEffect(() => {
    fetchData();
  }, [getAgentTasksFlag]);


  const fetchData = () => {
    setLoadingMessageFlag(true);
    // Fetch tasks from the server
    fetch(`${REACT_APP_SERVER_URL}GetAgentTasks?status=תבנית`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => response.json())
      .then((tasksData) => {
        // Process tasks data and update state
        if (Array.isArray(tasksData.tasks)) {
          setTasks(tasksData.tasks);
        } else {
          console.error("Expected an array but got:", tasksData.tasks);
        }
        setLoadingMessageFlag(false);
      })
      .catch((error) => {
        console.error("Error fetching tasks:", error);
      });
  };

  const calculateGroupDate = (dateValue) => {
    const date = new Date(dateValue * 1);
    date.setHours(0, 0, 0, 0); // Reset the time part to 00:00:00
    return date.getTime();
  };

  // Assuming `data` is your array of data objects
  tasks.forEach(item => {
    item.groupDate = calculateGroupDate(item.date_created);
  });



  const changeStatusToIrrelevant = async (task_id, taskName) => {
    try {
      const formData = new FormData();
      formData.append("comment", "Empty body");

      notify('מעבד תגובה', 'info', 3000);

      const requestURL = `${REACT_APP_SERVER_URL}CommentOnSubtasks?task_id=${task_id}&function=change_status`;

      await fetch(requestURL, {
        method: "POST",
        credentials: "include",
        body: formData, // Send formData as the request body
        // Headers are not manually set for multipart/form-data; the browser will set it
      })
        .then((response) => response.json())
        .then((response) => {
          if (response) {
            // props.refreshData();
            notify(`התבנית נמחקה בהצלחה!`, 'info', 3000);
            setGetAgentTasksFlag(!getAgentTasksFlag);
          } else {
            notify(`תקלה בשינוי סטטוס למשימה ${taskName}`, 'error', 3000);
          }
          return response;
        })
        .catch((error) => {
          notify(`תקלה בשינוי סטטוס למשימה ${taskName}: ${error.message}`, 'error', 3000);

        });
    }
    catch (error) {
      notify(`תקלה בשינוי סטטוס למשימה ${taskName}: ${error.message}`, 'error', 3000);


    }
  }




  const renderLoadingMessage = () => {
    if (loadingMessageFlag) {
      return (
        <div style={{ background: 'orange', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }} >
          <p style={{ color: 'white', textAlign: "center" }}>
            טוען נתונים    <br />
          </p>
          <LoadIndicator width={"24px"} height={"24px"} visible={true} />
        </div>
      );
    } else {
      return (
        <div style={{ background: 'lightblue', display: 'flex', flexDirection: 'row', justifyContent: 'right' }}>
          <Button
            // width="13%"
            // text="רענן תצוגה"
            // type="success"
            icon="refresh"
            marginRight="20px"
            onClick={() => setGetAgentTasksFlag(!getAgentTasksFlag)}
            padding="20px"
          />
          <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
          <div >

            {/* <div >סוג מסמך : {agreemntTypeData[selectedTypeIndex].text}</div> */}
            {/* <div >סטטוס&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: {statusData[selectedStatusIndex].text}</div> */}
          </div>




        </div>
      );
    }
  };

  const dataGridRef = useRef(null);

  const filterAgentTasks = () => {
    const dataGrid = dataGridRef.current?.instance;
    if (!dataGrid) {
      return;
    }

    let filtered = tasks;
    if (filtered !== null) {
      setIsLoadIndicatorVisible(false);
      setAgentTasks(filtered);
      if (agreementType === 'הכל' && status === 'הכל') {
        dataGrid.clearFilter();
        //   setfilterValue(null);
        return true;
      }

      var filteredType = []
      let status1 = ['status', 'contains', 'בוצע חלקי - ממתין ללקוח'];
      let status2 = ['status', 'contains', 'בוצע עם הערות'];
      let status3 = ['status', 'contains', 'לא בוצע - ממתין ללקוח'];
      let status4 = ['status', 'contains', 'ממתין לאחראי אהה'];
      let status5 = ['status', 'contains', 'ממתין לקישור'];
      let status6 = ['status', 'contains', 'בוצע - ממתין להשלמות'];
      let status7 = ['status', 'contains', 'לא בוצע - ממתין להשלמות'];

      let condition = ['clientResponse', '=', false];
      let waitingForMeFilter = [
        [
          [status1, 'or', status2, 'or', status3, 'or', status4, 'or', status5, 'or', status6, 'or', status7]
        ],
        'and',
        condition
      ];

      let waitingForBackofficeFilter = [['status', 'contains', 'ממתין לבדיקה'], 'or', ['clientResponse', '=', true]];
      let watingForSigner = ['status', 'contains', 'ממתין לחתימה'];




      if (agreementType === 'הסכמים') {
        filteredType = ['list_name', 'contains', 'הסכמ'];
      } else if (agreementType === 'אינטראקציות') {
        filteredType = ['list_name', 'contains', 'אינט']
      } else if (agreementType === 'הכל') {
        filteredType = null;
      }

      if (status === 'הכל') {
        // setfilterValue(filteredType);
        dataGrid.filter([filteredType]);
      } else {
        if (filteredType === null) {

          if (status === "ממתין לטיפולי")
            filteredType = waitingForMeFilter;

          else if (status === "בטיפול התפעול")
            filteredType = waitingForBackofficeFilter;

          else if (status === "ממתין לחתימה")
            filteredType = watingForSigner;
        }
        else {
          if (status === "ממתין לטיפולי")
            filteredType = [filteredType, 'and', waitingForMeFilter];

          else if (status === "בטיפול התפעול")
            filteredType = [filteredType, 'and', waitingForBackofficeFilter];

          else if (status === "ממתין לחתימה")
            filteredType = [filteredType, 'and', watingForSigner];
        }
        dataGrid.filter([filteredType]);
        // setfilterValue(filteredType);
      }

    }
    // if (status !== 'הכל') {
    //   setfilterValue(['status', '=', status] );
    //  // filtered = filtered?.filter(task => task.status.toLowerCase() === status.toLowerCase());
    // }else{
    //   setfilterValue(null);
    // }
  };

  const createStatusSortValue = (status) => {
    if (status === 'ממתין לאחראי אהה')
      return 1
    else if (status === 'לא בוצע - ממתין ללקוח')
      return 2
    else if (status === 'בוצע חלקי - ממתין ללקוח')
      return 3
    else if (status === 'בוצע עם הערות')
      return 4
    else if (status === 'ממתין לחתימה')
      return 5
    else if (status === 'ממתין לקישור')
      return 6
    else if (status === 'ממתין לבדיקה')
      return 7
    else
      return 1
  }



  useEffect(() => {
    filterAgentTasks();
  }, [agreementType, status, tasks]);

  // const handleCellClick = (e) => {
  //   setSelectedTask_id(e.task_id);
  //   setUploadPopupVisibility(true);
  // };
  const allowedPageSizes = [5, 10, 20, 50, 'all'];
  const onCellPrepared = (e) => {
    if (e.rowType === "data" && (e.column.dataField === "priorityName")) {
      e.cellElement.style.background = e.data.priorityColor;
      e.cellElement.className = "colorDiv";

      // Tracks the `Amount` data field
      e.watch(function () {
        return e.data.priority;
      }, function () {
        e.cellElement.style.color = e.data.priority >= 3 ? "green" : "red";
      })
    }
    if (e.rowType === "header") {
      e.cellElement.style.background = "grey";
      e.cellElement.style.color = "white";
    }
    if (e.rowType === "data" && (e.column.dataField === "status")) {
      e.cellElement.style.background = e.data.statusColor;
      e.cellElement.style.color = "white";
      e.cellElement.style.textAlign = "center";
      // e.cellElement.className ="colorDiv" ;
    }
  };

  const isAllowedStatusForDelete = (status) => {
    if (status === "טיוטה")
      return true;
    return false;
  }

  const handleEdit = (task_id, fid) => {
    window.open(getFormUrl(fid, task_id, user?.defaultFormView), '_blank')
  };

  const handleDelete = (task_id, taskName) => {
    setPopupMessageContent(` האם למחוק את \n ${taskName}?`);
    setSelectedTask_id(task_id);
    setSelectedTaskName(taskName);
    setMessagePopupVisibility(true);
  };

  const agreemntTypeData = [{ text: "הכל" }, { text: "הסכמים" }, { text: "אינטראקציות" }];
  // const statusData = [{ text: "הכל" }, { text: "ממתין לטיפולי" }, { text: "ממתין לחתימה" }, { text: "בטיפול התפעול" }];

  const displayDate = (dateString) => {
    const javaScriptRelease = new Date(Date.parse(dateString));
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    const formattedDate = javaScriptRelease.toLocaleString("en-GB", options);
    return formattedDate.replace(/\//g, '-');
  };

  const booleanToWords = (value) => {
    if (value === true)
      return "התקבלה תגובת מחתים"
    else if (value === false)
      return "לא התקבלה תגובת מחתים"
  }

  const lastSigningDate = (dateString) => {
    const javaScriptRelease = new Date(Date.parse(dateString));

    // Add 60 days to the date
    javaScriptRelease.setDate(javaScriptRelease.getDate() + 60);

    // Format the date as "dd-mm-yyyy"
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    };
    const formattedDate = javaScriptRelease.toLocaleString("en-GB", options);
    return formattedDate.replace(/\//g, '-');
  };


  const priorityCellRenderer = (data) => {
    return (
      <div className="colorDiv" style={{ borderRadius: '5px', boxShadow: '0 1px 3px rgba(0,0,0,.24)' }}>
        {data.value}
      </div>
    );
  };


  // const handleRowClick = (e) => {
  //   const { data } = e;
  //   handleClick(data.task_id)
  // };

  const getParameterFromUrl = (paramName) => {
    const url = window.location.href;

    // Extract the fragment part of the URL
    const fragmentIndex = url.indexOf('#');
    const fragment = url.slice(fragmentIndex + 1);

    // Extract the query parameters part from the fragment
    const queryParamsIndex = fragment.indexOf('?');
    const queryParams = fragment.slice(queryParamsIndex + 1);

    // Parse the query parameters part
    const urlParams = new URLSearchParams(queryParams);

    // Get the value of the parameter by name
    const paramValue = urlParams.get(paramName);

    // Check if paramValue is not null or undefined before returning
    if (paramValue) {
      return paramValue;
    }
  }

  return (

    <div>
      <div id="data-grid-demo" className={"content-block dx-card responsive-paddings"} style={{ padding: 0 }}>

        <Tabs
          id="typeTab"

          dataSource={agreemntTypeData}
          selectedIndex={selectedTypeIndex}
          scrollByContent
          showNavButtons={false}
          stylingMode={"primary"}
          onItemClick={(e) => {
            setAgreementType(e.itemData.text);
            setSelectedTypeIndex(e.itemIndex);
          }}
        />

        {/* <Tabs
          id="statusTab"
          dataSource={statusData}
          selectedIndex={selectedStatusIndex}
          scrollByContent
          showNavButtons={false}
          stylingMode={"secondary"}
          onItemClick={(e) => {
            setStatus(e.itemData.text);
            setSelectedStatusIndex(e.itemIndex); // Update selectedTabIndex state
            if (e.itemData.text === "ממתין לחתימה")
              setLastSigningDateColumnFlag(true);
            else
              setLastSigningDateColumnFlag(false);

          }}
        /> */}

        {renderLoadingMessage()}
        <DataGrid
          repaintChangesOnly={true}
          onCellPrepared={onCellPrepared}
          ref={dataGridRef}
          // defaultFilterValue={filterValue}
          // filterValue={filterValue}
          headerRowHeight={10}
          className={'dx-card wide-card'}
          dataSource={agentTasks}
          showBorders={false}
          keyExpr="task_id"

          columnAutoWidth={true}
          wordWrapEnabled={true}
          columnHidingEnabled={true}
          customizeColumns={(columns) => {
            columns.forEach((column) => {
              column.allowSearch = true;
            });
          }}

          onRowClick={(e) => {
            const targetClassList = e.event.target.classList;
            const rowData = e.data; // Get the row data
            if (targetClassList.contains('fa-trash')) {
              e.event.preventDefault();
              e.event.stopPropagation();
              handleDelete(rowData.task_id, rowData.name);
            } else {
              handleEdit(rowData.task_id, rowData.formId);
            }
          }}
        >
          <SearchPanel
            visible={true}
            placeholder='חיפוש'
            searchMode='contains'
            highlightSearchText={true}
          />

          <HeaderFilter visible={true} />
          {/* <FilterPanel visible={true}  /> */}
          <Grouping contextMenuEnabled={true} />
          <GroupPanel visible={true} /> {/* or "auto" */}
          <Paging defaultPageSize={10} />
          {/* <FilterRow visible={true} height={20}/> */}
          <Pager showPageSizeSelector={true} showInfo={true} allowedPageSizes={allowedPageSizes} />

          {/* <Toolbar>
          <Item location="before" widget="dxButton" options={{ text: 'רענן תצוגה', type: 'success', icon: 'refresh', }} />
          <Item name="searchPanel" />
      </Toolbar> */}

          <Column
            dataField="עריכה"
            allowFiltering={false}
            allowSorting={false}
            allowGrouping={false}
            width={90}
            cellRender={({ data }) => (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'right' }}>

                {isAllowedStatusForDelete(data.status) && (
                  <div onClick={() => handleDelete(data.task_id, data.name)} style={{ display: 'flex', flexDirection: 'row', alignItems: 'right' }}>
                    <i className="fas fa-trash" title="מחיקת מסמך" style={{ marginLeft: '8px', marginRight: '8px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', height: '100%' }} ></i>
                  </div>
                )}
                {/* TODO: uncomment when deploy load task */}
                {/* <div className='files' onClick={() => handleEdit(data.task_id, data.formId)} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: '100%', cursor: 'pointer' }}>
                  <i className="fas fa-file" title="מעבר לטופס" style={{ marginLeft: '8px', marginRight: '8px', cursor: 'pointer' }}></i>
                </div> */}
              </div>
            )}
          />

          <Column
            dataField="name"
            caption="שם תבנית"
            minWidth={10}
            allowFiltering={false}
            allowSorting={false}
            allowGrouping={false}
            cellRender={({ data }) => (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'right' }}>

                <div
                  // onClick={() => handleClick(data.task_id)}

                  style={{ display: 'flex', flexDirection: 'row', alignItems: 'right' }}
                >
                  {data.name}
                </div>
              </div>
            )}
          />
          <Column
            dataField="list_name"
            caption="סוג מסמך"
            sortIndex={1}
            minWidth={10}
            allowFiltering={true}
          />
          {/* <Column
            dataField="priorityName"
            caption="דחיפות"
            minWidth={10}
            alignment="center"
            allowFiltering={true}
            calculateSortValue={(rowData) => rowData.priority}
          /> */}

          <Column
            dataField="date_created"
            caption="תאריך יצירה"
            minWidth={10}
            allowFiltering={true}
            cellRender={({ data }) => (
              <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', direction: 'ltr' }}>
                {displayDate(new Date(data.date_created * 1))}
              </div>
            )}
            groupCellRender={({ value }) => (
              <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', direction: 'ltr' }}>
                {displayDate(new Date(value * 1))}
              </div>
            )}
          />

          <Column
            dataField="date_created"
            name={"lastSigningDate"}
            caption="מועד אחרון לחתימה"
            minWidth={10}
            visible={lastSigningDateColumnFlag}
            allowFiltering={true}
            sortOrder="asc" // or "desc" for descending order
            sortIndex={0} // if there are multiple sorted columns, use the appropriate index
            cellRender={({ data }) => (
              <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {lastSigningDate(new Date(data.date_created * 1))}
              </div>
            )}
            groupCellRender={({ value }) => (
              <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {lastSigningDate(new Date(value * 1))}
              </div>
            )}
          />
          {/* <Column dataField="status"
            caption="סטטוס"
            groupIndex={0}
            calculateSortValue={(rowData) => createStatusSortValue(rowData.status)}
          /> */}
          {/* <Column
            dataField="clientResponse"
            caption="תגובת מחתים"
            minWidth={10}
            allowFiltering={true}
            groupCellRender={({ value }) => (
              <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {booleanToWords(value)}
              </div>
            )}
          /> */}
          <Column dataField="task_id" visible={false} />
        </DataGrid>
        <VerifyPopup
          isMessagePopupVisible={isMessagePopupVisible}
          setMessagePopupVisibility={setMessagePopupVisibility}
          popupMessageContent={popupMessageContent}
          type={"error"}
          customFunction={() => { changeStatusToIrrelevant(selectedTask_id, selectedTaskName) }}
          title={"מחיקת מסמך"}
          button1Text={"אשר"}
          button2Text={"בטל"}
        />
      </div>
    </div>
  );

}

export default TempaleGrid;